const PSEvents = require('PSEvents');
const PSState = require('PSState');
const SlotUI = require('SlotUI');
const GenericUI = require('GenericUI').ui;
const { GameStates } = require('ClientStates');
const { boosterBetSupportedRtps } = require('LoadConfig');

const State = cc.Enum({
    ACTIVE:  'ACTIVE',
    PASSIVE:  'PASSIVE',
});

cc.Class({
    extends: cc.Component,

    properties: {
        boosterId: '[inserd id here]',
        targetNode: cc.Node,
        button: cc.Toggle,
        destoryOnDisable: true,
    },

    onLoad () {
        let specialBets = [];
        if (window.PSGames.CommonAPI &&
            window.PSGames.CommonAPI.SpecialBets &&
            window.PSGames.CommonAPI.SpecialBets.getSpecialBets
        )
        {
            specialBets = window.PSGames.CommonAPI.SpecialBets.getSpecialBets();
        }

        /**
         * TODO
         * Dirty workaround for checking the supported rtps, must be handled in WRAPPER
         */
        const isYggdrasilProvider = window.PSGames.launchParams.provider === 'yggdrasil';
        const rtpNumber = parseInt(window.PSGames.CommonAPI.Engine.getSessionState().rtp);
        const supportedRtp = isYggdrasilProvider ?
        !boosterBetSupportedRtps || boosterBetSupportedRtps && boosterBetSupportedRtps.includes(rtpNumber) :
        true;

        this.booster = specialBets.find(sp => sp.betType === this.boosterId);
        this.enabled = this.booster !== undefined &&
            !SlotUI.isReplayMode() &&
            SlotUI.isGoldenBetEnabled() &&
            supportedRtp;

        if (!this.targetNode) {
            this.targetNode = this.node;
        }
        if (!this.button) {
            this.button = this.node.getComponent(cc.Toggle);
        }
        if (!this.button) {
            this.button = this.node.getComponentInChildren(cc.Toggle);
        }
        if (!this.button) {
            cc.warn('[BoosterFeatureButton]: no toggle button found');
            this.targetNode.active = false;
            return;
        }

        if (this.enabled) {
            this.init();
        } else if (this.destoryOnDisable) {
            this.targetNode.destroy();
        } else {
            this.targetNode.active = false;
        }
    },

    init () {
        this.locked = false;
        this._deactivate();

        this._uiEnabledListener = () => this._onUiEnabled();
        this._spinRequestListener = () => this._deactivate();
        this._roundEndedListener = () => this._onRoundEnded();
        this._autoplayStarted = () => this.hide();
        this._autoplayEnded = () => this._onAutoplayEnded();
        this._gameResumeListener = () => this._onUiEnabled();
        this._stateUpdated= () => this._onStateUpdated();

        PSEvents.subscribe(PSEvents.SPIN_REQUEST, this._spinRequestListener);
        PSEvents.subscribe(PSEvents.GAME_ROUND_ENDED, this._roundEndedListener);
        PSEvents.subscribe(PSEvents.AUTOPLAY_START, this._autoplayStarted);
        PSEvents.subscribe(PSEvents.AUTOPLAY_ENDED, this._autoplayEnded);
        PSEvents.subscribe(PSEvents.GAME_RESUMED, this._gameResumeListener);
        PSEvents.subscribe(PSEvents.STATE_UPDATED, this._stateUpdated);

        PSEvents.getLastOrSubscribe(PSEvents.UI_ENABLED, this._uiEnabledListener);

        this.button.isChecked = Boolean(PSState.selectedBooster);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.SPIN_REQUEST, this._spinRequestListener);
        PSEvents.unsubscribe(PSEvents.GAME_ROUND_ENDED, this._roundEndedListener);
        PSEvents.unsubscribe(PSEvents.AUTOPLAY_START, this._autoplayStarted);
        PSEvents.unsubscribe(PSEvents.AUTOPLAY_ENDED, this._autoplayEnded);
        PSEvents.unsubscribe(PSEvents.GAME_RESUMED, this._gameResumeListener);
        PSEvents.unsubscribe(PSEvents.STATE_UPDATED, this._stateUpdated);

        this.targetNode = null;
    },

    _canBeActivated () {
        const isMain = PSState.gameState === GameStates.MAIN;

        return isMain && this.enabled && !SlotUI.isWinRestore() && !GenericUI.freeRoundFlag() && !SlotUI.isReplayMode();
    },

    _onUiEnabled() {
        if (GenericUI.freeRoundFlag() || GenericUI.isAutoplay()) {
            this.hide();
        } else {
            this.show();
            if (this._canBeActivated()) {
                this._activate();
            } else {
                this._deactivate();
            }
        }
    },

    _onRoundEnded () {
        if (GenericUI.freeRoundFlag() || GenericUI.isAutoplay()) {
            this.hide();
        } else {
            this.show();
            if (this._canBeActivated()) {
                this._activate();
            } else {
                this._deactivate();
            }
        }
    },

    _onAutoplayEnded () {
        if (!GenericUI.isGameRoundActive()) {
            this._onRoundEnded();
        }
    },

    _activate () {
        if (this.state === State.ACTIVE) {
            return;
        }
        this.state = State.ACTIVE;
        this.button.interactable = true;
        this._updateButtonState();
        this.node.emit('activated');
    },
    _deactivate () {
        if (this.state === State.PASSIVE) {
            return;
        }
        this.state = State.PASSIVE;
        this._updateButtonState();
        this.node.emit('deactivated');
    },

    _updateButtonState() {
        this.button.interactable = this.state === State.ACTIVE && !this.locked;
    },

    _onStateUpdated() {
        this.button.isChecked = Boolean(PSState.selectedBooster);
    },

    lock () {
        this.locked = true;
        this._updateButtonState();
    },

    unlock () {
        this.locked = false;
        this._updateButtonState();
    },

    hide () {
        if (this.enabled && this.targetNode) {
            this.targetNode.active = false;
        }
    },

    show () {
        if (this.enabled && this.targetNode) {
            this.targetNode.active = true;
        }
    },

    uncheck() {
        PSState.set({ selectedBooster: null });
    },

    check() {
        PSState.set({ selectedBooster: this.booster });
    },

    onChecked () {
        if (!this.enabled) {
            cc.error('Trying to change the booster state when its not enabled');
            return;
        }
        if (this.node) {
            this.node.emit('checked', this.button.isChecked);
        }

        if (this.button.isChecked) {
            this.check();
        } else {
            this.uncheck();
        }
    }
});
